module.exports = __webpack_public_path__ + "img/00024.a334395c.webp";